import { CallcardFormatterService } from '@addins/core/core';
import { Injectable } from '@angular/core';
import { StampManagerType } from '@models/imported/SagaBase';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CCaller } from '@models/imported/SagaSchema/CCaller';
import { CEvent } from '@models/imported/SagaSchema/CEvent';
import { CFormLink } from '@models/imported/SagaSchema/CFormLink';
import { CPatient } from '@models/imported/SagaSchema/CPatient';
import { CStampCard } from '@models/imported/SagaSchema/CStampCard';
import { ListCardStatus } from '@models/imported/SagaStateLib/ListCardStatus';
import { CacheAction } from '@services/cache/cacheEvent';
import { FetchListService } from '@services/fetchlist/fetchlist.service';
import { IModelService, IObjectChange, ModelService } from '@services/model-factory';

@ModelService(CallCard)
@Injectable()
export class CallcardModelService implements IModelService<CallCard> {
  constructor(private fetchListService: FetchListService, private cardFormatter: CallcardFormatterService) {}

  change(change: IObjectChange<CallCard>) {
    const callcard: CallCard = change.target;

    this.setStatus(callcard);

    if (change.action === CacheAction.removed) {
      callcard.callers.length = 0;
      return;
    }

    callcard.callers = callcard.component<CCaller>(CCaller).concat([]);
    callcard.callers.sort((a, b) => b.LineOwner - a.LineOwner);

    callcard.event = callcard.component<CEvent>(CEvent).length
      ? callcard.component<CEvent>(CEvent).find(event => event.IsSubsequent === false)
      : null;

    callcard.component<CFormLink>(CFormLink).sort((a, b) => a.compare(b));
    callcard.component<CPatient>(CPatient).sort((a, b) => a.PatientNumber - b.PatientNumber);

    this.setPreattributionStamp(callcard);

    this.cardFormatter.format(callcard);
  }

  private setStatus(callcard: CallCard) {
    if (callcard.component(CStampCard).length > 0) {
      const statusStamps = callcard.component<CStampCard>(CStampCard).filter(stamp => stamp.StampType === StampManagerType.Status);
      statusStamps.sort((a, b) => b.CreatedUTC.getTime() - a.CreatedUTC.getTime());
      if (statusStamps.length) {
        const statusStamp = statusStamps[0];
        callcard.status = this.fetchListService.getRow(ListCardStatus, statusStamp.Status);
      }
    }

    if (!callcard.status) {
      callcard.status = this.fetchListService.getRow(ListCardStatus, 1);
    }
  }

  private setPreattributionStamp(callcard: CallCard) {
    const preattributionStamps = callcard
      .component<CStampCard>(CStampCard)
      .filter(stamp => stamp.StampType === StampManagerType.PreAttributionUnitActivity);
    preattributionStamps.sort((a, b) => b.CreatedUTC.getTime() - a.CreatedUTC.getTime());

    callcard.preattribution = preattributionStamps.length ? preattributionStamps[0] : null;
  }
}
